import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import {Map as MapComponent} from './Map.js';
import colors from './colors.js';


const useStyles = makeStyles(theme => ({
  medScreenRoot: {
    height: `calc(100vh - ${theme.spacing(8)}px)`,
    width: '100%',
    backgroundColor: colors.blue,
    display: 'flex',
  },
  doctorListContainer: {
    padding: theme.spacing(2),
    width: theme.spacing(40),
    flex: `0 0 ${theme.spacing(40)}px`,
    height: '100%',
    paddingTop: 0,
    flexDirection: "column",
    display: "flex",
  },
  doctorList: {
    paddingTop: theme.spacing(2),
    flexGrow: 1,
    overflow: "scroll",

  },
  doctorListHeaderText: {
    paddingTop: theme.spacing(2),
    color: colors.pink
  },
  doctorListHeaderSubtext: {
    color: colors.pink,
    fontSize: "12px",
  },
  doctorListHeaderDivider: {
    backgroundColor: colors.pink,
  },
  doctorListHeader: {
    margin: 0,
    fontSize: '16px',
    color: colors.grey,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  mapContainer: {
    width: '100%',
  },
}));

export const DesktopMapView = (props) => {
  const classes = useStyles();
  return (
    <div ref={props.mapRef} className={classes.medScreenRoot}>
      <div className={classes.mapContainer}>
        <MapComponent
          center={props.currentCenter}
          zoom={props.currentZoom}
          doctors={props.doctorsList}
          handleCenterChange={props.handleCenterChange}
          onMouseOver={d => props.setHoverDoctor(d.id)}
          onMouseOut={() => {
            props.setHoverDoctor(null);
          }}
          setZoom={props.setZoom}
          setLastZoom={props.setLastZoom}
          lastZoom={props.lastZoom}
          onClick={props.selectDoctor}
          hoverDoctor={props.hoverDoctor}
          selectedDoctor={props.selectedDoctor}
        />
      </div>
      <div className={classes.doctorListContainer}>
        <Typography className={classes.doctorListHeaderText} align="left" variant="h4" paragraph>
          {props.mapCopy.mapTitle}
        </Typography>
        <Typography className={classes.doctorListHeaderSubtext} align="left" variant="body1" paragraph>
          <i>
            {props.mapCopy.mapTitleSubtext}
          </i>
        </Typography>
        <Divider className={classes.doctorListHeaderDivider} light />
        <div className={classes.doctorList}>
          {props.doctorsList.map(d => (
            <p
              style={{
                margin: 0,
                backgroundColor:
                  props.selectedDoctorId === d.id
                    ? colors.pink
                    : props.hoverDoctor === d.id
                    ? colors.pink
                    : 'transparent',
                color:
                  props.selectedDoctorId === d.id
                    ? colors.blue
                    : props.hoverDoctor === d.id
                    ? colors.blue
                    : colors.grey,
                cursor: 'pointer',
              }}
              onMouseOver={() => {
                props.setHoverDoctor(d.id)
              }}
              onMouseOut={() => {
                props.setHoverDoctor(null);
              }}
              onClick={() => props.selectDoctor(d)}
            >
              {`${d.name}, ${d.specialty}, ${d.city}`}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}
